// extracted by mini-css-extract-plugin
export default {"form":"Form-form_myidc","fieldUpload":"Form-fieldUpload_K7i5Z","uploadSuccess":"Form-uploadSuccess_s2q38"};